// Firebase Configuration
// Configuración para Firebase Cloud Messaging (Push Notifications)

import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyCvB8UquCWSycwm6RPWvtjFZJeE-fogV4c",
  authDomain: "confianzabackoffice.firebaseapp.com",
  projectId: "confianzabackoffice",
  storageBucket: "confianzabackoffice.firebasestorage.app",
  messagingSenderId: "746274715891",
  appId: "1:746274715891:web:6c17efb5d8d236c7ba9f86"
};

// VAPID Key (Web Push certificate)
// Firebase Console → Project Settings → Cloud Messaging → Web Push certificates
export const VAPID_KEY = 'BIRqyP5yzf-dptoOi3D9W0vBVRHAleCLJz6kfxVchVpyh1Wf9TW3w3vtl5lzOJ_gq1XO23TEjAHqegDxmPBrrds';

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Inicializar Firebase Cloud Messaging
let messaging = null;
try {
  messaging = getMessaging(app);
} catch (error) {
  console.error('Error initializing Firebase Messaging:', error);
}

/**
 * Solicita permiso para notificaciones y obtiene el token FCM
 * @returns {Promise<string|null>} Token FCM o null si falla
 */
export const requestNotificationPermission = async () => {
  try {
    // Verificar si el navegador soporta notificaciones
    if (!('Notification' in window)) {
      console.warn('Este navegador no soporta notificaciones');
      return null;
    }

    // Verificar si Firebase Messaging está disponible
    if (!messaging) {
      console.warn('Firebase Messaging no está disponible');
      return null;
    }

    // Solicitar permiso al usuario
    const permission = await Notification.requestPermission();

    if (permission === 'granted') {
      console.log('✅ Permiso de notificaciones concedido');

      // Obtener token FCM
      const token = await getToken(messaging, {
        vapidKey: VAPID_KEY
      });

      if (token) {
        console.log('📱 Token FCM obtenido:', token);
        return token;
      } else {
        console.warn('No se pudo obtener el token FCM');
        return null;
      }
    } else {
      console.warn('Permiso de notificaciones denegado');
      return null;
    }
  } catch (error) {
    console.error('Error al solicitar permiso de notificaciones:', error);
    return null;
  }
};

// Guardar referencia al único callback para evitar múltiples listeners
let messageCallback = null;
let listenerRegistered = false;

/**
 * Escucha mensajes cuando la app está en primer plano
 * @param {Function} callback - Función a ejecutar cuando llega un mensaje
 * @returns {Function} Función para desuscribirse del listener
 */
export const onMessageListener = (callback) => {
  if (!messaging) {
    console.warn('Firebase Messaging no está disponible');
    return () => {};
  }

  // Solo registrar el listener UNA VEZ
  if (!listenerRegistered) {
    console.log('🔔 Registrando listener FCM único');
    onMessage(messaging, (payload) => {
      console.log('📬 Mensaje FCM recibido (foreground):', payload);
      if (messageCallback) {
        messageCallback(payload);
      }
    });
    listenerRegistered = true;
  }

  // Actualizar el callback
  messageCallback = callback;

  // Retornar función de cleanup
  return () => {
    messageCallback = null;
  };
};

export { messaging };
